import React from "react"
import { Link } from "gatsby"
import { FaBars } from "react-icons/fa"

let toggleNavbar = () => {
    let nav = document.getElementById("nav-list");
    nav.classList.toggle("h-48");
    nav.classList.toggle("opacity-100");
    nav.classList.toggle("pointer-events-none");
  };

const Nav = () => (
    <nav>
        <div className="container relative z-10 flex flex-col justify-between py-6 md:flex-row">
            <div className="flex justify-between w-full md:w-auto">
                <Link to="/">
                    <img src="/logo.svg" alt="Khaled Elbalal" className="block h-10 text-4xl font-bold"/>
                </Link>
                <button className="my-auto text-3xl md:hidden" onClick={toggleNavbar}><FaBars/></button>
            </div>
            <ul className="block h-0 pt-2 my-auto list-none opacity-0 pointer-events-none md:pointer-events-auto md:block md:opacity-100 md:h-auto md:pt-0" id="nav-list">
                <li className="block py-1 my-auto md:inline-block md:ml-6"><Link className="hover:font-bold" to="/">Home</Link></li>
                <li className="block py-1 my-auto md:inline-block md:ml-6"><Link className="hover:font-bold" to="/#about">About</Link></li>
                <li className="block py-1 my-auto md:inline-block md:ml-6"><Link className="hover:font-bold" to="/#portfolio">Portfolio</Link></li>
                <li className="block py-1 my-auto mb-2 md:mb-0 md:inline-block md:ml-6"><Link to="/blog/" className="hover:font-bold">Blog</Link></li>
                <li className="block my-auto md:inline-block md:ml-6"><Link to="/contact/" className="block text-center btn-cta md:inline md:text-left">Contact</Link></li>
            </ul>
        </div>
    </nav>
)

export default Nav